module.exports = __webpack_public_path__ + "img/media-folder.576ed2e8.svg";